/*
 * @Description: 自动优化规则数据模块
 * @Author: yanzhigen@batmobi.net
 * @Date: 2018-11-06 14:16:29
 * @LastEditors: yanzhigen@batmobi.net
 * @LastEditTime: 2018-11-12 10:26:15
 */
export default {
    state: {
        editParamTemplate: () => {
            return {
                name: '',
                type: 1,
                conditionArr: [],
                conditionObject: {
                    1: { indicator: 1, operator: 1, indicatorValue: '' },
                    2: { indicator: 2, operator: 1, indicatorValue: '' },
                    3: { indicator: 3, operator: 1, indicatorValue: '' },
                    4: { indicator: 4, operator: 1, indicatorValue: '' },
                    5: { indicator: 5, operator: 1, indicatorValue: '' },
                    6: { indicator: 6, operator: 1, indicatorValue: '' },
                    7: { indicator: 7, operator: 1, indicatorValue: '' },
                    8: { indicator: 8, operator: 1, indicatorValue: '' },
                    9: { indicator: 9, operator: 1, indicatorValue: '' },
                },
                timeType: 'day',
                time: '',
                status: 1,
                statusEdit: 1,
                campaignIds: '',
            };
        },
        //筛选的状态列表
        statusList: {
            0: '全部',
            1: 'ON',
            2: 'OFF',
        },
        //维度
        dimensionValue: {
            1: '广告组',
            2: '广告',
            3: '国家',
            // 4: '广告位',
            5: '媒体',
        },
        dimensionList: [
            { label: '广告组', value: 1 },
            { label: '广告', value: 2 },
            { label: '国家', value: 3 },
            // { label: '广告位', value: 4 }
            { label: '媒体', value: 5 },
        ],
        //事件范围
        timeList: {
            day: '天',
            hour: '小时',
        },
        //条件
        quotaList: [
            { label: 'CTR', value: 1 },
            { label: 'CVR', value: 2 },
            { label: '展示量', value: 3 },
            // { label: 'eCPM', value: 4 },
            { label: '点击量', value: 5 },
            { label: '转化量', value: 6 },
            { label: 'CPM', value: 7 },
            { label: 'CPC', value: 8 },
            { label: 'CPA', value: 9 },
        ],
        //条件
        quotaValue: {
            1: 'CTR',
            2: 'CVR',
            3: '展示量',
            4: 'eCPM',
            5: '点击量',
            6: '转化量',
            7: 'CPM',
            8: 'CPC',
            9: 'CPA',
        },
        //大于小于
        mathList: [{ label: '>', value: 1 }, { label: '<', value: 2 }],
        //大于小于
        mathValue: {
            1: '>',
            2: '<',
        },
        //单位列表
        unitList: {
            1: '%',
            2: '%',
            3: '千次',
            4: '$',
            5: '次',
            6: '次',
            7: '$',
            8: '$',
            9: '$',
        },
        //操作
        actionList: {
            1: '关闭广告组',
            2: '关闭广告',
            3: '拉黑国家',
            4: '拉黑广告位',
            5: '拉黑媒体',
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/autoOptimization.js